import axios from 'axios'
import { getCountryCode, getMainLanguageCode } from 'src/consumer/services'
import { commonHeadersMPWeb, supportApiURL } from './services'

const SUPPORT_TWO_FACTOR_BASE = '/api/secure/cc/support/twofactor'

function getSupportHeaders() {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()

  return {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...commonHeadersMPWeb,
    'ef-user-country-code': countryCode,
    'ef-app-language': mainLanguageCode,
  }
}

function extractPayload(response) {
  return (
    response?.data?.data?.supportTwoFactor ||
    response?.data?.supportTwoFactor ||
    response?.data?.data ||
    response?.data ||
    {}
  )
}

export async function getSupportTwoFactorStatus() {
  const response = await axios.get(`${supportApiURL}${SUPPORT_TWO_FACTOR_BASE}/status`, {
    headers: getSupportHeaders(),
  })
  return extractPayload(response)
}

export async function startSupportTwoFactorChallenge(method) {
  const response = await axios.post(
    `${supportApiURL}${SUPPORT_TWO_FACTOR_BASE}/challenge/start`,
    method ? { method } : {},
    { headers: getSupportHeaders() },
  )
  return extractPayload(response)
}

export async function resendSupportTwoFactorChallenge(method) {
  const response = await axios.post(
    `${supportApiURL}${SUPPORT_TWO_FACTOR_BASE}/challenge/resend`,
    method ? { method } : {},
    { headers: getSupportHeaders() },
  )
  return extractPayload(response)
}

export async function verifySupportTwoFactorChallenge(otp) {
  const response = await axios.post(
    `${supportApiURL}${SUPPORT_TWO_FACTOR_BASE}/challenge/verify`,
    { otp },
    { headers: getSupportHeaders() },
  )
  return extractPayload(response)
}
